import { ClubMemberProperty } from "./types";
import moment from "moment/moment";
import { parseDate } from "chrono-node";
import { FormInput } from "@form/index";
import { TFunction } from "i18next";
import { Key } from "react";

/**
 * @description Normalizes the boolean-ish values a switch property can carry (true/false, 1/0, "1"/"0", "true"/"false")
 * @param value
 */
export const isSwitchPropertyValueOn = (value: any): boolean =>
    value === true || value === 1 || value === "1" || value === "true";

/**
 * @description Formats a stored property value for display (dates localized, switches as yes/no)
 * @param value
 * @param type
 * @param t optional translator, falls back to german labels
 */
export const formatClubMemberPropertyValue = ((value: any, type: ClubMemberProperty["type"], t?: TFunction): string => {
    switch (type) {
        case "date":
            return value ? moment(parseDate(value)).format("l") : "-";

        case "switch":
            if (value === null || value === undefined || value === "") return "-";
            return isSwitchPropertyValueOn(value)
                ? t?.("propertyManager.switchValues.yes") ?? "Ja"
                : t?.("propertyManager.switchValues.no") ?? "Nein";

        default:
            return value || "-";
    }
});

/**
 * @description Renders the form control matching a property type
 * @param property
 * @param props
 */
export const renderFieldForProperty = (property: ClubMemberProperty, props?: {
    key?: Key
    name: string
    label: string
}) => {
    switch (property?.type) {
        case "iban":
            return <FormInput.IBAN {...props} />;
        case "switch":
            return <FormInput.Switch {...props} defaultValue={false} />;
        case "date":
            return <FormInput.DatePicker {...props} />;
        case "number":
            return <FormInput type="number" {...props} />;
        case "text_multiline":
            return <FormInput.Textarea {...props} />;
        case "select":
            return (
                <FormInput.Select
                    {...props}
                    options={property.options?.options.map(o => ({ label: o.label, key: o.label }))}
                />
            );
        default:
            return <FormInput {...props} />;
    }
};

/**
 * @description Converts a string to a currency string
 * @param str
 * @param length
 */
export const blurString = (str: string, length: number = 2) => {
    if (str.length <= length) return str;
    const blurredPart = str.slice(length).replace(/./g, "*");
    return str.slice(0, length) + blurredPart;
};


export const fieldMappings: { key: string, title: string }[] = [
    { key: "number", title: "Mitgliedsnummer" },
    { key: "firstname", title: "Vorname" },
    { key: "lastname", title: "Nachname" },
    { key: "gender", title: "Geschlecht" },
    { key: "email", title: "E-Mail Adresse" },
    { key: "street", title: "Straße und Hausnummer" },
    { key: "postalcode", title: "PLZ" },
    { key: "city", title: "Stadt" },
    { key: "group", title: "Gruppe" },
    { key: "category", title: "Kategorie" },
    { key: "remarks", title: "Notizen" },
    { key: "entry_date", title: "Eintrittsdatum" },
    { key: "exit_date", title: "Austrittsdatum" },
    { key: "ads", title: "Arbeitsdienst" },
    { key: "birthday", title: "Geburtsdatum" },
    { key: "age", title: "Alter am Exportdatum" },
    { key: "phone", title: "Telefon" },
    { key: "created_at", title: "Erstellt am" }
];